export enum ContextualMenuActions {
    Edit = 0,
    Delete = 1
}